module.exports = __webpack_public_path__ + "static/media/10.e9653a63.gif";